import { atom } from 'jotai';

interface UnreadCountInfo {
  allUnreadCount: number;
  platformUnreadCount: number;
  personalUnreadCount: number;
}

// 站内信未读消息数量对象
export const unreadCountInfoAtom = atom<UnreadCountInfo>({
  // 全部消息未读数量（platform和personal）
  allUnreadCount: 0,
  // 平台消息未读数量
  platformUnreadCount: 0,
  // 个人消息未读数量
  personalUnreadCount: 0,
});